import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './auth/layout/auth-layout/auth-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { ProjectLayoutComponent } from './core/layouts/project-layout/project-layout.component';
import { ALL_ROUTES } from './core/routes/all-routes';
import { DeviceLayoutComponent } from './device-onboarding/layout/device-layout/device-layout.component';
import { onboardingGuard } from './core/guards/onboarding.guard';

const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),

  },
  {
    path: 'setup',
    component: DeviceLayoutComponent,
    canActivate: [authGuard, onboardingGuard],
    loadChildren: () => import('./device-onboarding/device-onboarding.module').then((m) => m.DeviceOnboardingModule),

  },
  {
    path: '',
    component: ProjectLayoutComponent,
    children: ALL_ROUTES,
    canActivate: [authGuard,onboardingGuard],
  },
  //   {
  //   path: '**',
  //   redirectTo: '/dashboard',
  // }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})



export class AppRoutingModule { }
